import { render } from "./EditBrand.vue?vue&type=template&id=1facde6c"
import script from "./EditBrand.vue?vue&type=script&lang=js"
export * from "./EditBrand.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/alaediin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__